import { Component, inject } from '@angular/core';
import { NgIf, AsyncPipe } from '@angular/common';
import { AttachmentUploadService } from 'src/app/service/file-upload/file-upload.service';
import { LoaderService } from 'src/app/service/loader/loader.service';

@Component({
  selector: 'vex-file-upload-loader',
  standalone: true,
  imports: [NgIf, AsyncPipe],
  template: `
    <div class="loader-container" *ngIf="isLoading$ | async">
      <div id="loader" class="text-center">
        <div class="loader mx-auto mb-4">
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p>
          One moment please... <br />
          <span
            >Uploading: {{ uploadedFilesCount() }}/{{ totalFilesCount() }}</span
          ><br />
          <span class="text-black text-base">
            Progress: {{ uploadProgress() }}%</span
          >
        </p>
      </div>
    </div>
  `
})
export class FileUploadLoaderComponent {
  private loaderService = inject(LoaderService);
  private fileUploadService = inject(AttachmentUploadService);

  isLoading$ = this.loaderService.fileUploadLoading$;

  // Accessing file upload progress and counts from FileUploadService
  uploadProgress = this.fileUploadService.uploadProgress;
  uploadedFilesCount = this.fileUploadService.uploadedFilesCount;
  totalFilesCount = this.fileUploadService.totalFilesCount;
}
